import {
  ApproverFilled,
  ConstructionSiteEquipmentFilled,
  CustomFilled,
  MeetingFilled,
  PangZhanFilled,
  ProjectManagementFilled,
  PurseFilled,
  SettingsFilled,
  ShieldFilled,
  TaskFilled,
  WorkingHoursFilled,
} from '@pangu/icons-react';

export const iconMap = new Map([
  ['ApproverFilled', <ApproverFilled />],
  ['ConstructionSiteEquipmentFilled', <ConstructionSiteEquipmentFilled />],
  ['CustomFilled', <CustomFilled />],
  ['MeetingFilled', <MeetingFilled />],
  ['PangZhanFilled', <PangZhanFilled />],
  ['ProjectManagementFilled', <ProjectManagementFilled />],
  ['PurseFilled', <PurseFilled />],
  ['SettingsFilled', <SettingsFilled />],
  ['ShieldFilled', <ShieldFilled />],
  ['TaskFilled', <TaskFilled />],
  ['WorkingHoursFilled', <WorkingHoursFilled />],
]);
